import { Box, makeStyles, Typography } from "@material-ui/core";
import { SvgImage } from "../../../images/svg";
import React from "react";

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 500,
    color: "#114668",
    marginLeft: "18px",
  },
  box: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
    height: 150,
    width: "100%",
    backgroundColor: "#fff",
    border: "3px solid #efeff2",
    margin: 5,
    borderRadius: 10,
    padding: "24px",
  },
  imageContainer: {
    width: "65px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
}));

const BlocksSoundsItem = ({ label, image, onClick }) => {
  const classes = useStyles();

  return (
    <Box className={classes.box} onClick={onClick}>
      <Box className={classes.imageContainer}>
        <SvgImage type={image} />
      </Box>
      <Typography className={classes.title}>{label}</Typography>
    </Box>
  );
};

export default BlocksSoundsItem;
